import React, { useMemo } from 'react';
import styled from 'styled-components';
import config from '@/configs/config';

const Img = styled.img`
  position: relative;
  &[alt]:after {  
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    font-family: 'Helvetica';
    font-weight: 300;
    line-height: 2;  
    text-align: center;
    content: attr(alt);
  }
`;

export default (props) => {
  const {
    src = null,
  } = props || {};

  const parsedSrc = useMemo(() => {
    if (!src) return '';
    if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) return src;
    return `${config.RESOURCE_URI}${src}`;
  }, [src]);

  return <Img {...props} src={parsedSrc} alt="" />;
};
